/**
 * Labstep
 *
 * @module screens/Notification/Index
 * @desc Notifications Index Screen
 */

import { LayoutMainContentCenter } from 'labstep-web/components/Layout/MainContent/Center';
import { NotificationListContainer as Notifications } from 'labstep-web/components/Notification/List';
import { DocumentHead } from 'labstep-web/core/DocumentHead';

const title = 'Notifications';

export const Index = () => (
  <>
    <DocumentHead title={title} />
    <LayoutMainContentCenter>
      <Notifications />
    </LayoutMainContentCenter>
  </>
);

export default Index;
